module.exports = __webpack_public_path__ + "tap.mp3";